/**
 * Object xử lý event global trên toàn bộ hệ thống
 * @author DNThang - 17.03.2020
 */

import mitt from "mitt";

const emitter = mitt();

export default {
  $on: (event, handler) => emitter.on(event, handler),
  $off: (event, handler) => emitter.off(event, handler),
  $emit: (event, data) => emitter.emit(event, data),
};

/**
 * Đối tượng liệt kê các global event đang có
 * Bắt buộc có globalEvent nào đều phải cấu hình vào đây để không bị trùng tên
 * @author DNThang - 17.03.2020
 */
const GlobalEventName = {
  /**
   * Xử lý đóng tất form
   */
  loadRouter: "loadRouter",
  loadData: "loadData",
  closeAllPopup: "closeAllPopup",
  scrollEvent: "scrollEvent",
  reloadList: "reloadList",
  resetPopupCenter: "resetPopupCenter",
  setWaitingConfirm: "setWaitingConfirm",
  showHelpViewHistory: "showHelpViewHistory",
  sortEvent: "sortEvent",
  updateTransferNotification: "updateTransferNotification",
  closeAllDropdown: "closeAllDropdown",
  checkTaxDeclarationProcedure: "checkTaxDeclarationProcedure",
  checkTaxPaymentProcedure: "checkTaxPaymentProcedure",
};

export { GlobalEventName };
